export function resolveAuthRedirectUri(
  configuredUri: string,
  currentOrigin: string,
  warmupOrigin?: string,
): string {
  if (!warmupOrigin?.trim()) return configuredUri;

  const configured = new URL(configuredUri);
  const warmup = new URL(warmupOrigin.trim());
  if (
    configured.protocol !== "https:" ||
    configured.username || configured.password || configured.hash ||
    warmup.protocol !== "https:" ||
    warmup.username || warmup.password || warmup.port ||
    warmup.pathname !== "/" || warmup.search || warmup.hash ||
    !/^app-landagility-frontend-production-warmup(?:-[a-z0-9]+)?(?:\.[a-z0-9-]+)?\.azurewebsites\.net$/.test(warmup.hostname) ||
    warmup.origin === configured.origin
  ) {
    throw new Error("Invalid production warmup authentication configuration.");
  }

  if (currentOrigin !== warmup.origin) return configuredUri;
  return new URL(`${configured.pathname}${configured.search}`, warmup.origin).href;
}
